import { formatNearAmount as formatNearAmountUtil } from '@near-js/utils';

import { formatTokenAmount } from 'utils/amounts';

const NEAR_FRACTIONAL_DIGITS = 5;

export const formatNearAmount = (amount: string) => {
  amount = amount.toString();
  if (amount === '0') {
    return amount;
  }
  const formattedAmount = formatNearAmountUtil(
    amount,
    NEAR_FRACTIONAL_DIGITS
  );
  if (formattedAmount === '0') {
    return `< ${
      !NEAR_FRACTIONAL_DIGITS
        ? '0'
        : `0.${'0'.repeat((NEAR_FRACTIONAL_DIGITS || 1) - 1)}1`
    }`;
  }
  return formattedAmount;
};

export const formatWithCommas = (value: string) => {
  const pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(value)) {
    value = value.toString().replace(pattern, '$1,$2');
  }
  return value;
};

export const getRoundedBalanceInFiat = (
  rawNearAmount: string,
  tokenFiatValue: string,
  isNear: boolean,
  decimals?: number
) => {
  const formattedNearAmount =
    rawNearAmount && isNear
      ? formatNearAmount(rawNearAmount).replace(/,/g, '')
      : formatTokenAmount(rawNearAmount, decimals);

  const balanceInFiat = Number(formattedNearAmount) * Number(tokenFiatValue);
  const roundedBalanceInFiat = balanceInFiat && balanceInFiat.toFixed(2);

  if (roundedBalanceInFiat === '0.00' || formattedNearAmount === '< 0.00001') {
    return '< $0.01';
  }
  return roundedBalanceInFiat;
};
